import React, {Fragment} from "react";
import {withRouter} from "react-router-dom";
import {Badge} from "reactstrap";

class RegistrationStatusBadgeComponent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            status: this.props.status !== undefined ? this.props.status : "",
            statusArr: this.props.statuses !== undefined ? this.props.statuses : []
        }
    }

    render() {
        return <Fragment>
            {
                this.state.statusArr.map((status, index) => {
                    return <Fragment key={index}>
                        {status.name === this.state.status &&
                        <Badge key={status.name} pill color={status.colour} style={{
                            flex: "1",
                            fontSize: "10pt",
                            margin: "auto"
                        }}>{status.displayName}</Badge>
                        }
                    </Fragment>
                })}
        </Fragment>
    }
}

export default withRouter(RegistrationStatusBadgeComponent);